import React, { useEffect, useState } from "react";
import "../PersonalizeLearningDialog/PersonalizeLearningDialog.scss";
import GraphIcon from "../../assets/images/vactor/success-check.svg";
import TimeIcon from "../../assets/images/vactor/time-icon.svg";
import { Dialog, DialogContent } from "@mui/material";
import { PrimaryButton } from "../AllButtons/AllButtons";
import { useAppDispatch } from "../../Store/store";
import { setIsPaymentDone } from "../../Slice/userSlice";
import { useNavigate } from "react-router-dom";


const PaymentSuccessDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [dialogOpen, setDialogOpen] = useState(false);
  // const [showNextDialog, setShowNextDialog] = useState(false);

  useEffect(() => {
    setDialogOpen(true);
    dispatch(setIsPaymentDone());
  }, [dispatch]);

  const handleClose = () => {
    setDialogOpen(false);
    navigate("/dashboard");
  };

  return (
    <>
      <div className="personalize-dialog-wrapper">
        <Dialog
          open={dialogOpen}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="personalize-dialog"
        >
          <DialogContent>
            <div className="personalize-dialog-body">
              <div className="personalize-icon">
                <img src={GraphIcon} alt="" />
              </div>
              <div className="personalize-dialog-title">
                Payment Successful! You’ve successfully upgraded your plan.
              </div>
              <div className="personalize-dialog-dsc">
                Your plan has been upgraded. Thank you for choosing YULI!
              </div>
              <div className="personalize-action-btn">
                <PrimaryButton onClick={() => navigate("/dashboard")}>
                  Close
                </PrimaryButton>
              </div>
              <div className="time-note">
                <img src={TimeIcon} alt="" /> Takes about 10 minutes to complete
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {/* {showNextDialog && (
        <PersonalizeLearningDialog
          open={showNextDialog}
          onClose={() => setShowNextDialog(false)}
        />
      )} */}
    </>
  );
};

export default PaymentSuccessDialog;
